module.exports = __webpack_public_path__ + "tim-bennetto-1d32d88ce07c1dde7e442a284ff1d07a.webp";